// extracted by mini-css-extract-plugin
export default {"bg-holder-home":"Home_bg-holder-home__laG6a"};